import React from 'react';
import { compose, mapProps, onlyUpdateForKeys, withProps } from 'recompose';
import { omit } from 'ramda';
import { RACE_RULE_STATUSES } from '../../constants';
import withCountDown from '../../common/CountDown/withCountDown';
import style from './index.scss';

export const Title = ({ label, value, className = '' }) => <span className={className}>
        {label}&nbsp;<span className={style.countdown}>{value}</span>
</span>;

export const statuses = {
    NOT_STARTED: RACE_RULE_STATUSES.approved,
    COMPLETED: RACE_RULE_STATUSES.completed
};

export default compose(
    onlyUpdateForKeys(['status', 'endTime', 'startTime']),
    withProps(
        () => ({
            statuses,
            tKeyPrefix: 'games.category.'
        })
    ),
    withCountDown,
    mapProps(omit(['statuses']))
)(Title);
